import { createSlice } from "@reduxjs/toolkit";
import { sortAllView } from "../utils";

const coManufacturingOrderDefaultColumns = [
  "CO-MANF NO",
  "CO-MANF",
  "CO-MANF WHS",
  "ETA",
  "PRIORITY",
  "CURRENCY",
  "CREATED BY",
  "DESTINATION WHS",
  "STATUS",
];

const initialState = {
  coManufacturingOrder: { count: 0, results: [] },
  coManufacturingOrderParams: { limit: 10, offset: 0 },
  coManufacturingOrderSelection: [],
  coManufacturingOrderDetail: null,
  coManufacturingOrderLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: coManufacturingOrderDefaultColumns,
      allViews: { "Default View": coManufacturingOrderDefaultColumns },
      nameOfViews: [],
    },
  },
};

const manufacturingOrderSlice = createSlice({
  name: "manufacturingOrder",
  initialState,
  reducers: {
    getCoManufacturingOrder: (state, action) => {
      state.coManufacturingOrder = action.payload;
    },
    getCoManufacturingOrderDetail: (state, action) => {
      state.coManufacturingOrderDetail = action.payload;
    },
    clearCoManufacturingOrderDetail: state => {
      state.coManufacturingOrderDetail = null;
    },
    getCoManufacturingOrderSelection: (state, action) => {
      state.coManufacturingOrderSelection = action.payload;
    },
    setCoManufacturingOrderParams: (state, action) => {
      state.coManufacturingOrderParams = action.payload;
    },
    updateCoManufacturingOrderParams: (state, action) => {
      state.coManufacturingOrderParams = { ...state.coManufacturingOrderParams, ...action.payload };
    },
    resetCoManufacturingOrderParams: state => {
      state.coManufacturingOrderParams = {
        limit: state.coManufacturingOrderParams.limit || 10,
        offset: 0,
      };
    },
    setCoManufacturingOrderLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.coManufacturingOrderLayout = {
        ...state.coManufacturingOrderLayout,
        listView: {
          ...state.coManufacturingOrderLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: {
            ...state.coManufacturingOrderLayout.listView.allViews,
            ...views.list.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },
  },
});

export const {
  getCoManufacturingOrder,
  getCoManufacturingOrderDetail,
  clearCoManufacturingOrderDetail,
  getCoManufacturingOrderSelection,
  setCoManufacturingOrderParams,
  updateCoManufacturingOrderParams,
  resetCoManufacturingOrderParams,
  setCoManufacturingOrderLayoutAllViews,
} = manufacturingOrderSlice.actions;

export default manufacturingOrderSlice.reducer;
